// extracted by mini-css-extract-plugin
export default {"contentVideo":"VideoSlide_contentVideo__Xe00H","poster":"VideoSlide_poster__lmsDg","play":"VideoSlide_play__MAZxv","title":"VideoSlide_title__hLBxQ"};